import { url } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class GetDeliveryDatesForPostcode {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService;

    /**
     * GetDeliveryDatesForPostcode constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Get the delivery days via API for requested postcode.
     *
     * @param {String} postcode
     * @param {Number} numberOfDeliveryDays
     *
     * @returns {Promise}
     */
    async handle(postcode, numberOfDeliveryDays) {
        let apiUrl = url(ApiEndpoints['postcodes.delivery-days'], [postcode, numberOfDeliveryDays]);

        return this.apiService.get(apiUrl);
    }
}
